import typescriptFsa from "typescript-fsa";
import { InvoiceDataResult } from "@stores/v201910/domain/invoice/type";

const actionCreator = typescriptFsa("INVOICE_201910");

// JSON
export const downloadJissekiJson = actionCreator.async<void, InvoiceDataResult>(
  "DOWNLOAD_JISSEKI_JSON"
);
